import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../util/state/GlobalContextProvider";
import ImportFromFileErrorsTable, { KeyPrefixValues } from "../../sales_marketing/component/ImportFromFileErrorsTable";



const useDownloadTemplate = (
    keyPrefix:KeyPrefixValues,
    fileForImport:File | undefined,
    setFileForImport:React.Dispatch<React.SetStateAction<File | undefined>>,
    importFile:(file: File, tenantId: string, dealerId: string) => Promise<any>,
    getSuccessMessage:(insertedPoi:number) => String,
    setOpenUploadWarning:React.Dispatch<React.SetStateAction<boolean>>,
    setPoiTableShouldUpdate?:React.Dispatch<React.SetStateAction<boolean>>
    ) => {
    const [importFromFileResponseResultStatus,setImportFromFileResponseResultStatus] = useState<{importFromFileResponseResult:any,isImportFromFileSuccess:boolean | undefined}>({
        importFromFileResponseResult:undefined,
        isImportFromFileSuccess:undefined
    });
    const {globalData} = useContext(GlobalContext);
    const tenant = globalData?.user?.legalEntities.map((it: any) => it.name)[0];
    const dealer = globalData?.user?.dealers.map((it: any) => it.name)[0];

    const onSuccess = (keyPrefix:KeyPrefixValues) => (response:any) => {
        let numberOfErrorRows;
        let insertedRows;
        if(keyPrefix === 'poi'){
            numberOfErrorRows = response.result.numberOfErrorInPoiInsert;
            insertedRows = response.result.numberOfInsertedPoi;
        } else {
            numberOfErrorRows = response.result.numberOfErrorInVoucherInsert
            insertedRows = response.result.numberOfInsertedVoucher;
        }
        if (response.status === 'OK' && numberOfErrorRows === 0 ) {
            setImportFromFileResponseResultStatus({
                importFromFileResponseResult:insertedRows + getSuccessMessage(insertedRows),
                isImportFromFileSuccess:true
            })
            setOpenUploadWarning(true);
            setPoiTableShouldUpdate?.(true);
        } else {
            setImportFromFileResponseResultStatus({
                importFromFileResponseResult:response.result,
                isImportFromFileSuccess:false
            })
            setOpenUploadWarning(true);
        }
    }

    useEffect(() => {
        if (fileForImport) {
            // Upload file
            importFile(fileForImport,tenant,dealer)
                .then(onSuccess(keyPrefix))
                .finally(() => {
                    setFileForImport(undefined);
                });
        }
        
    }, [fileForImport])

    const renderModalContent = () =>{
        if(!importFromFileResponseResultStatus.isImportFromFileSuccess){
            return <ImportFromFileErrorsTable data={importFromFileResponseResultStatus.importFromFileResponseResult} keyPrefix={keyPrefix}/>
        } else {
            return <p>{importFromFileResponseResultStatus.importFromFileResponseResult}</p>
        }
    }


    return {
        importFromFileResponseResultStatus,
        renderModalContent
    }


}

export default useDownloadTemplate;


